"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactReducer = void 0;
var state_init_1 = require("@/pages/common/components/contact/state.init");
var actions_1 = require("@/pages/common/components/contact/actions");
var typesafe_actions_1 = require("typesafe-actions");
var contactReducer = function (state, action) {
    if (state === void 0) { state = state_init_1.defaultContactState; }
    switch (action.type) {
        case typesafe_actions_1.getType(actions_1.default.setOnLoaded): {
            return __assign(__assign({}, state), { isDomLoaded: action.payload });
        }
    }
    return state;
};
exports.contactReducer = contactReducer;
